import { createComponent } from '@carvana/merch-components';
import { legacyBreakpoints } from '@carvana/merch-tailwind/breakpoints';
import styled from 'styled-components';
import commonMaxWidth from '~/constants/commonMaxWidth';
import BackArrow from '~/icons/BackArrow';
import BaseBackIcon from '~/icons/BackArrow';
import DeliveryMedium from '~/icons/DeliveryMedium';
import VehicleSearch from '~/icons/VehicleSearch';
import VendingMedium from '~/icons/VendingMedium';

export const DeliveryAndPickupWrapper = styled.div.attrs({
  className: 'border border-grey-2 m-auto rounded-[6px]'
})`
  max-width: ${commonMaxWidth}px;

  & > div:nth-child(2) {
    border-top: solid 1px var(--cvna-color-grey-2);
  }
`;

export const TransitCharge = createComponent('div', {
  className: 'mt-4 text-center text-grey-5 tl-body-s m:tl-body-m'
});

export const Wrapper = createComponent('div', {
  className: 'mt-12 flex w-full flex-col content-center border border-grey-2'
});

export const HeaderWrapper = styled.div.attrs({
  className:
    'gap-x-12 grid items-center mx-16 py-12 tl-header-s m:gap-x-32 m:mx-32'
})`
  grid-template-columns: 32px 1fr auto;
  grid-template-rows: 32px;

  @media (min-width: ${legacyBreakpoints.m}px) {
    grid-template-columns: 56px 1fr auto;
    grid-template-rows: 48px;
  }
`;

export const Text = createComponent('p', {
  className: 'text-blue-7'
});

export const LinkTextUppercase = createComponent('span', {
  className: 'anchor uppercase'
});

export const LinkTextUnderline = createComponent('span', {
  className: 'anchor underline'
});

export const LinkWrapper = createComponent('div', {
  className: 'flex flex-row items-center justify-end gap-4'
});

export const VehicleSearchIcon = styled(VehicleSearch)`
  width: 32px;
  height: 32px;

  @media (min-width: ${legacyBreakpoints.m}px) {
    width: 52px;
    height: 52px;
  }
`;

export const DeliveryMediumIcon = styled(DeliveryMedium)`
  @media (max-width: ${legacyBreakpoints.m}px) {
    width: 32px;
    height: 32px;
  }
`;

export const VendingIcon = styled(VendingMedium)`
  @media (max-width: ${legacyBreakpoints.m}px) {
    width: 32px;
    height: 32px;
  }
`;

export const DownArrowIcon = styled(BackArrow)`
  height: 16px;
  width: 16px;
  transform: ${props =>
    props.isExpanded ? 'rotate(90deg)' : 'rotate(-90deg)'};
`;

export const ContentWrapper = createComponent('div', {
  className:
    'mx-24 flex flex-col gap-8 border-t border-grey-2 py-24 text-grey-5'
});

export const ContentHeader = createComponent('p', {
  className: 'text-blue-7 tl-header-s m:tl-header-m'
});

export const ContentText = createComponent('p', {
  className: 'text-grey-5 tl-body-s m:tl-body-m'
});

export const OpenRecallText = styled.p`
  font-size: 14px;
  margin-bottom: 20px;
  line-height: 24px;

  @media (min-width: ${legacyBreakpoints.m}px) {
    font-size: 16px;
    margin-bottom: 24px;
  }
`;

export const GetStartedArrow = styled(BaseBackIcon)`
  stroke: var(--cvna-color-blue-6);
  transform: rotate(180deg);
`;
